import {
  CheckCircle as ApprovedIcon,
  Cancel as RejectedIcon,
  Upload as SubmittedIcon,
  Description as DocumentIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Info as InfoIcon,
} from "@mui/icons-material";

/**
 * Action type configuration mapping
 * Maps each action type to its icon, color, and display label
 */
export const ACTION_TYPE_CONFIGS = {
  STAGE_SUBMITTED: {
    icon: <SubmittedIcon />,
    color: "info",
    label: "Submitted",
  },
  STAGE_APPROVED: {
    icon: <ApprovedIcon />,
    color: "success",
    label: "Approved",
  },
  STAGE_REJECTED: {
    icon: <RejectedIcon />,
    color: "error",
    label: "Rejected",
  },
  STAGE_RETURNED: {
    icon: <RejectedIcon />,
    color: "warning",
    label: "Returned",
  },
  DOCUMENT_ADDED: {
    icon: <DocumentIcon />,
    color: "primary",
    label: "Document Added",
  },
  DOCUMENT_DELETED: {
    icon: <DeleteIcon />,
    color: "error",
    label: "Document Deleted",
  },
  DOCUMENT_UPDATED: {
    icon: <DocumentIcon />,
    color: "info",
    label: "Document Updated",
  },
  STAGE_DATA_FIELD_UPDATED: {
    icon: <EditIcon />,
    color: "default",
    label: "Field Updated",
  },
  STAGE_DATA_ENTERED: {
    icon: <AddIcon />,
    color: "primary",
    label: "Data Entered",
  },
  STAGE_CREATED: {
    icon: <AddIcon />,
    color: "success",
    label: "Stage Created",
  },
  STAGE_ACTIVATED: {
    icon: <ApprovedIcon />,
    color: "success",
    label: "Stage Activated",
  },
  STAGE_DEACTIVATED: {
    icon: <RejectedIcon />,
    color: "warning",
    label: "Stage Deactivated",
  },
  FIELD_UPDATED: {
    icon: <EditIcon />,
    color: "default",
    label: "Field Updated",
  },
  REMARKS_ADDED: {
    icon: <AddIcon />,
    color: "info",
    label: "Remarks Added",
  },
  REMARKS_UPDATED: {
    icon: <EditIcon />,
    color: "info",
    label: "Remarks Updated",
  },
  COMBINED_STAGE_SUBMISSION: {
    icon: <SubmittedIcon />,
    color: "info",
    label: "Combined Submission",
  },
  COMBINED_STAGE_APPROVED: {
    icon: <ApprovedIcon />,
    color: "success",
    label: "Combined Approval",
  },
  COMBINED_STAGE_REJECTED: {
    icon: <RejectedIcon />,
    color: "error",
    label: "Combined Rejection",
  },
  RFI_ADDITION_CREATED: {
    icon: <AddIcon />,
    color: "primary",
    label: "Addition Created",
  },
  RFI_ADDITION_UPDATED: {
    icon: <EditIcon />,
    color: "info",
    label: "Addition Updated",
  },
  RFI_ADDITION_DELETED: {
    icon: <DeleteIcon />,
    color: "error",
    label: "Addition Deleted",
  },
  RFI_ADDITIONS_BULK_CREATED: {
    icon: <AddIcon />,
    color: "primary",
    label: "Bulk Additions",
  },
  RFI_ADDITION_FIELD_UPDATED: {
    icon: <EditIcon />,
    color: "default",
    label: "Addition Field Updated",
  },
  CHECKBOX_UPDATED: {
    icon: <EditIcon />,
    color: "default",
    label: "Checkbox Updated",
  },
  MESSAGE_ADDED: {
    icon: <AddIcon />,
    color: "info",
    label: "Message Added",
  },
  MESSAGE_UPDATED: {
    icon: <EditIcon />,
    color: "info",
    label: "Message Updated",
  },
  MESSAGE_DELETED: {
    icon: <DeleteIcon />,
    color: "error",
    label: "Message Deleted",
  },
  STAGE_SKIPPED: {
    icon: <InfoIcon />,
    color: "warning",
    label: "Stage Skipped",
  },
  STAGE_UNSKIPPED: {
    icon: <InfoIcon />,
    color: "info",
    label: "Stage Unskipped",
  },
};

/**
 * Get action type configuration
 * Returns default config if action type not found
 */
export const getActionTypeConfig = (actionType) => {
  return ACTION_TYPE_CONFIGS[actionType] || {
    icon: <InfoIcon />,
    color: "default",
    label: actionType?.replace(/_/g, " ") || "Unknown",
  };
};
